// !Deprecated 09-feb-2026
// import * as AccordionPrimitive from '@radix-ui/react-accordion'
// import { FC } from 'react'

// import { ArrowIconDownward } from '../../assets'
// import { contentRowV2Type } from './content-row.types'

// const Accordion = AccordionPrimitive.Root

// export const ContentRow: FC<contentRowV2Type> = ({
//   headerRow,
//   accordionRow,
//   footerRow,
// }) => {
//   return (
//     <div className="my-6 flex w-full flex-col rounded-lg p-2 border border-[1px] border-grey-20">
//       <Accordion type="single" collapsible className="w-full">
//         <AccordionPrimitive.Item
//           value="item1"
//           className="pb-2 pl-2 pr-4 pt-[6px] "
//         >
//           <AccordionPrimitive.Header className="m-0 flex w-full py-1">
//             <div className="flex w-full">{headerRow}</div>
//             <AccordionPrimitive.Trigger className="m-0 cursor-pointer border-0 bg-white p-0 ps-3 outline-0 transition-all [&[data-state=open]>svg]:rotate-180">
//               <ArrowIconDownward />
//             </AccordionPrimitive.Trigger>
//           </AccordionPrimitive.Header>
//           <AccordionPrimitive.Content className="dropdown-scrollbar overflow-x-auto overflow-y-hidden text-sm leading-none transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
//             <div className="my-3">{accordionRow}</div>
//           </AccordionPrimitive.Content>
//         </AccordionPrimitive.Item>
//       </Accordion>
//       <div className="w-full">{footerRow}</div>
//     </div>
//   )
// }


import { FC, useState } from 'react';

import { ArrowIconDownward } from '../../assets';
import { contentRowV2Type } from './content-row.types';

export const ContentRow: FC<contentRowV2Type> = ({ headerRow, accordionRow, footerRow }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-grey-20 my-6 flex w-full flex-col rounded-lg border border-[1px] p-2">
      {/* Header */}
      <div className="pb-2 pl-2 pr-4 pt-[6px]">
        <div className="m-0 flex w-full py-1">
          <div className="flex w-full">{headerRow}</div>

          <button
            onClick={() => setOpen((prev) => !prev)}
            className="m-0 cursor-pointer border-0 bg-white p-0 ps-3 outline-0"
          >
            <div className={`transition-all ${open ? 'rotate-180' : ''}`}>
              <ArrowIconDownward />
            </div>
          </button>
        </div>
      </div>

      {/* Content */}
      <div
        className={`dropdown-scrollbar overflow-x-auto overflow-y-hidden text-sm leading-none transition-all duration-200 ${
          open ? 'my-3 max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        {open && <div>{accordionRow}</div>}
      </div>

      {/* Footer */}
      <div className="w-full">{footerRow}</div>
    </div>
  );
};
